import type { CSSProperties } from 'react'

interface ScopeProps {
  audience: string
  sensitive?: boolean
  style?: CSSProperties
}

/**
 * "Visible to: …" indicator.
 * Sensitive variant uses ochre + △ glyph (Rule 10).
 * Default glyph is ◐ (partial visibility).
 */
export function Scope({ audience, sensitive = false, style }: ScopeProps): JSX.Element {
  return (
    <span
      data-testid="scope"
      data-sensitive={sensitive ? 'true' : 'false'}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        fontSize: 11,
        color: sensitive ? 'var(--warning-fg)' : 'var(--text-2)',
        background: sensitive ? 'var(--warning-bg)' : 'rgba(107, 99, 89, 0.08)',
        padding: '2px 8px',
        borderRadius: 4,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      <span aria-hidden="true" style={{ fontSize: 10 }}>
        {sensitive ? '△' : '◐'}
      </span>
      Visible to: {audience}
    </span>
  )
}
